import React, { useState, useEffect } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import MILAMI_LOGO_URL from '../assets/images/background01.png';

function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isHomePage = location.pathname === '/';

  return (
    <nav className={`fixed top-0 w-full z-[100] transition-all duration-500 ${
      isScrolled || !isHomePage
        ? 'bg-slate-950/80 backdrop-blur-md shadow-[0_4px_30px_rgba(37,99,235,0.1)] py-3 border-b border-blue-900/50' 
        : 'bg-transparent py-5 border-b border-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6 flex justify-between items-center">
        
        <Link to="/" className="flex items-center gap-3 group">
          {/* THE HEXAGON LOGO CONTAINER - SOLID WHITE BACKGROUND */}
          <div 
            className="h-10 w-10 bg-white flex items-center justify-center"
            style={{ clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)' }}
          >
            <img 
              src={MILAMI_LOGO_URL} 
              alt="ilami Technologies" 
              className="h-full w-full object-contain p-1" 
            />
          </div>
          <span className="text-xl font-bold tracking-tight text-white">
            iLAMI <span className="text-blue-500 font-normal">Technologies</span>
          </span>
        </Link>

        <div className="hidden md:flex gap-8">
          {['Home', 'About', 'Services', 'Portfolio', 'Careers', 'Contact'].map((item) => (
            <NavLink
              key={item}
              to={item === 'Home' ? '/' : `/${item.toLowerCase().replace(' ', '')}`}
              className={({ isActive }) => `relative text-xs uppercase tracking-[0.2em] font-bold transition-colors duration-300 pb-2
                after:content-[''] after:absolute after:w-full after:h-[2px] after:bottom-0 after:left-0 
                after:bg-blue-500 after:transition-transform after:duration-300 after:ease-out after:origin-left
                ${isActive 
                  ? 'text-blue-400 after:scale-x-100' 
                  : 'text-slate-300 hover:text-white after:scale-x-0 hover:after:scale-x-100' 
                }`
              }
            >
              {item}
            </NavLink>
          ))}
        </div>
        <button onClick={() => setIsOpen(!isOpen)} className="md:hidden text-blue-400 hover:text-blue-300 transition-colors p-2">
          <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16m-7 6h7"} />
          </svg>
        </button>
      </div>
      <div className={`md:hidden absolute top-full left-0 w-full bg-slate-950/95 backdrop-blur-xl border-t border-blue-900/50 transition-all duration-300 ${isOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}`}>
        <ul className="flex flex-col p-6 gap-4">
          {['Home', 'About', 'Services', 'Portfolio', 'Careers', 'Contact'].map((item) => (
            <Link 
              key={item} 
              to={item === 'Home' ? '/' : `/${item.toLowerCase().replace(' ', '')}`}
              onClick={() => setIsOpen(false)}
              className="block text-slate-300 font-bold uppercase text-xs tracking-widest hover:text-blue-400 hover:translate-x-2 transition-all duration-300"
            >
              {item}
            </Link>
          ))}
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;